import { useState } from "react";
import { useLocation } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";
import { Link } from "react-router-dom";

/**
 * WrongUpi component displays an error message for invalid UPI details.
 * Shows entered UPI ID and provides navigation to edit it.
 */
const WrongUpi = ({ login = null }) => {
  const location = useLocation();
  // const { userId } = useParams();

  const gpaydetails = location.state?.gpaydetails || "";
  const userId = location.state?.userId || "";
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')



  return (
    <>
      <div className="container mt-4">
        <div className="row">
          <div className="col-md-12 pancard-data">
            <div className="text-center mb-7">
              <img
                width="100"
                alt="icon"
                src={toAbsoluteUrl("/media/images/invalid.png")}
              />
              <h6 className="mt-5">UPI is not Valid</h6>
            </div>

            <div className="px-5">
              <h4 className="mb-5">Details Entered As Per You</h4>
              <label>UPI ID</label>
              <p>{gpaydetails}</p>
            </div>

            <div className="btns cn-btn mt-15 d-flex">
              <Link to={`/${redirectUrl}/add-upi/${userId}`}>
                <button
                  type="button"
                  className="btn bgdark-blue text-white"
                // onClick={handleEditClick}
                >
                  Edit
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WrongUpi;
